import NO_EFFECT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_no_effect_fill_24.svg';

import FADE_SMOOTH_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_fade_smooth_fill_24.svg';
import FADE_BLACK_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_fade_black_fill_24.svg';

import PUSH_BOTTOM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_push_bottom_fill_24.svg';
import PUSH_LEFT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_push_left_fill_24.svg';
import PUSH_RIGHT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_push_right_fill_24.svg';
import PUSH_TOP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_push_top_fill_24.svg';

import SWITCH_LEFT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_switch_left_fill_24.svg';
import SWITCH_RIGHT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_switch_right_fill_24.svg';

import CUT_NONE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cut_none_fill_24.svg';
import CUT_BLACK_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cut_black_fill_24.svg';

import PULL_RIGHT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_right_fill_24.svg';
import PULL_TOP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_top_fill_24.svg';
import PULL_LEFT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_left_fill_24.svg';
import PULL_BOTTOM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_bottom_fill_24.svg';
import PULL_RIGHT_UP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_right_up_fill_24.svg';
import PULL_RIGHT_DOWN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_right_down_fill_24.svg';
import PULL_LEFT_UP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_left_up_fill_24.svg';
import PULL_LEFT_DOWN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_pull_left_down_fill_24.svg';

import COVER_RIGHT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_right_fill_24.svg';
import COVER_TOP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_top_fill_24.svg';
import COVER_LEFT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_left_fill_24.svg';
import COVER_BOTTOM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_bottom_fill_24.svg';
import COVER_RIGHT_UP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_right_up_fill_24.svg';
import COVER_RIGHT_DOWN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_right_down_fill_24.svg';
import COVER_LEFT_DOWN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_left_down_fill_24.svg';
import COVER_LEFT_UP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_cover_left_up_fill_24.svg';

import WARP_ENLARGE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_wrap_enlarge_fill_24.svg';
import WARP_NARROW_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_wrap_narrow_fill_24.svg';
import NEWSFLASH_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_wrap_zoom_rotate_fill_24.svg';

import FLIP_LEFT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_flip_right_fill_24.svg';
import FLIP_RIGHT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_flip_left_fill_24.svg';

import GALLERY_LEFT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_gallery_right_fill_24.svg';
import GALLERY_RIGHT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_gallery_left_fill_24.svg';

import PRISM_BOTTOM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_prism_bottom_fill_24.svg';
import PRISM_TOP_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_prism_top_fill_24.svg';
import PRISM_LEFT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_prism_left_fill_24.svg';
import PRISM_RIGHT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_prism_right_fill_24.svg';

import FLASH_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_transition_flash_fill_24.svg';


export {
    NO_EFFECT_ICON,
    FADE_SMOOTH_ICON,
    FADE_BLACK_ICON,
    PUSH_BOTTOM_ICON,
    PUSH_LEFT_ICON,
    PUSH_RIGHT_ICON,
    PUSH_TOP_ICON,
    SWITCH_LEFT_ICON,
    SWITCH_RIGHT_ICON,
    CUT_NONE_ICON,
    CUT_BLACK_ICON,
    PULL_RIGHT_ICON,
    PULL_TOP_ICON,
    PULL_LEFT_ICON,
    PULL_BOTTOM_ICON,
    PULL_RIGHT_UP_ICON,
    PULL_RIGHT_DOWN_ICON,
    PULL_LEFT_UP_ICON,
    PULL_LEFT_DOWN_ICON,
    COVER_RIGHT_ICON,
    COVER_TOP_ICON,
    COVER_LEFT_ICON,
    COVER_BOTTOM_ICON,
    COVER_RIGHT_UP_ICON,
    COVER_RIGHT_DOWN_ICON,
    COVER_LEFT_DOWN_ICON,
    COVER_LEFT_UP_ICON,
    WARP_ENLARGE_ICON,
    WARP_NARROW_ICON,
    NEWSFLASH_ICON,
    FLIP_LEFT_ICON,
    FLIP_RIGHT_ICON,
    GALLERY_LEFT_ICON,
    GALLERY_RIGHT_ICON,
    PRISM_BOTTOM_ICON,
    PRISM_TOP_ICON,
    PRISM_LEFT_ICON,
    PRISM_RIGHT_ICON,
    FLASH_ICON,
};
